module.exports = __webpack_public_path__ + "static/media/whisky_hero_tablet.d625b62a.jpg";